import { render, staticRenderFns } from "./ModalDeleteConfirmationBatch.vue?vue&type=template&id=d8b6e448&scoped=true"
import script from "./ModalDeleteConfirmationBatch.vue?vue&type=script&lang=js"
export * from "./ModalDeleteConfirmationBatch.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteConfirmationBatch.vue?vue&type=style&index=0&id=d8b6e448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b6e448",
  null
  
)

export default component.exports